import { createSelector } from 'reselect'

import { mapPartnerIds } from '../helpers/mapPartnerIds'
import { orderKeys } from '../helpers/orderKeys'
import { sortPartnerIds } from '../helpers/sortPartnerIds'

import { selectComposedReportState } from './selectComposedReportState'

export const selectFilterWasChanged = createSelector(
  [selectComposedReportState],
  ({
    geo,
    partnersInScope,
    scopeValue,
    pbms,
    partnersType,
    products,
    managers,
    acknowledged,
    amplifyMembership,
    lastAppliedFilter,
    fYear,
    specializations,
    isAcknowledged,
  }) => {
    if (!lastAppliedFilter) {
      return false
    }

    return (
      JSON.stringify(
        orderKeys({
          ...lastAppliedFilter,
          partnersInScope: sortPartnerIds(lastAppliedFilter.partnersInScope.map(mapPartnerIds)),
        })
      ) !==
      JSON.stringify(
        orderKeys({
          geo,
          partnersInScope: sortPartnerIds(partnersInScope.map(mapPartnerIds)),
          scopeValue,
          pbms,
          products,
          managers,
          acknowledged,
          amplifyMembership,
          fYear,
          partnersType,
          specializations,
          isAcknowledged,
        })
      )
    )
  }
)
